import { render } from "./MainAllianceView.vue?vue&type=template&id=84f4c0d4"
import script from "./MainAllianceView.vue?vue&type=script&lang=js"
export * from "./MainAllianceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__